module.exports = __webpack_public_path__ + "static/cc-31630b00735e49956914fe55aad328d3.jpg";